import { render, staticRenderFns } from "./BaseImageUploadInput.vue?vue&type=template&id=2df68f52&scoped=true"
import script from "./BaseImageUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseImageUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseImageUploadInput.vue?vue&type=style&index=0&id=2df68f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df68f52",
  null
  
)

export default component.exports